import settingsSlice from "../slices/settingsSlice";

export const {
  requestTimePeriod,
  successTimePeriod,
  failureTimePeriod,
  updateTimePeriodRequest,
  updateTimePeriodSuccess,
  updateTimePeriodFailure,
  requestArtifactPeriod,
  successArtifactPeriod,
  failureArtifactPeriod,
  updateArtifactPeriodRequest,
  updateArtifactPeriodSuccess,
  updateArtifactPeriodFailure,
  requestGetMailingConfigs,
  successGetMailingConfigs,
  failureGetMailingConfigs,
  requestSetMailingConfigs,
  successSetMailingConfigs,
  failureSetMailingConfigs,
  requestGetMailRecipients,
  successGetMailRecipients,
  failureGetMailRecipients,
  requestAddMailRecipients,
  successAddMailRecipients,
  failureAddMailRecipients,
  requestDeleteMailRecipients,
  successDeleteMailRecipients,
  failureDeleteMailRecipients,
  requestResetMailingConfigs,
  successResetMailingConfigs,
  failureResetMailingConfigs,
  requestUpdateMailingActive,
  successUpdateMailingActive,
  failureUpdateMailingActive,
  requestGetMaliciousSubmissionMailContent,
  successGetMaliciousSubmissionMailContent,
  failureGetMaliciousSubmissionMailContent,
  requestSetMaliciousSubmissionMailContent,
  successSetMaliciousSubmissionMailContent,
  failureSetMaliciousSubmissionMailContent,
  requestResetMaliciousSubmissionMailContent,
  successResetMaliciousSubmissionMailContent,
  failureResetMaliciousSubmissionMailContent,
  dumpDatabaseRequest,
  requestDumpStatus,
  updateDumpStatus,
  requestRestoreStatus,
  updateRestoreStatus,
  requestGetSyslogConfig,
  successGetSyslogConfig,
  failureGetSyslogConfig,
  requestSetSyslogConfig,
  successSetSyslogConfig,
  failureSetSyslogConfig,
  requestDeleteSyslogConfig,
  successDeleteSyslogConfig,
  failureDeleteSyslogConfig,
  requestSetTelegramConfig,
  successSetTelegramConfig,
  failureSetTelegramConfig,
  requestGetTelegramConfig,
  successGetTelegramConfig,
  failureGetTelegramConfig,
  requestSetSlackConfig,
  successSetSlackConfig,
  failureSetSlackConfig,
  requestGetSlackConfig,
  successGetSlackConfig,
  failureGetSlackConfig,
  RequestCustomSignatureUpload,
  SuccessCustomSignatureUpload,
  FailureCustomSignatureUpload,
  SetCustomSignatureFile,
  RequestCustomSignatures,
  SuccessCustomSignatures,
  FailureCustomSignatures,
  RequestDeleteCustomSignature,
  SuccessDeleteCustomSignature,
  FailureDeleteCustomSignature,
  RequestEditCustomSignature,
  SuccessEditCustomSignature,
  FailureEditCustomSignature,
  RequestGetHostname,
  SuccessGetHostname,
  FailureGetHostname,
  RequestSetHostname,
  SuccessSetHostname,
  FailureSetHostname,
  RequestUniqueId,
  SuccessUniqueId,
  FailureUniqueId,
  RequestTestSyslogServer,
  SuccessTestSyslogServer,
  FailureTestSyslogServer,
  RequestGetPrtgConfigs,
  SuccessGetPrtgConfigs,
  FailureGetPrtgConfigs,
  RequestSetPrtgConfigs,
  SuccessSetPrtgConfigs,
  FailureSetPrtgConfigs,
  RequestGetUpdateSchedulerConfigs,
  SuccessGetUpdateSchedulerConfigs,
  FailureGetUpdateSchedulerConfigs,
  RequestSetUpdateSchedulerConfigs,
  SuccessSetUpdateSchedulerConfigs,
  FailureSetUpdateSchedulerConfigs,
  RequestGetLdapStatus,
  SuccessGetLdapStatus,
  FailureGetLdapStatus,
  RequestGetLdapConfigs,
  SuccessGetLdapConfigs,
  FailureGetLdapConfigs,
  RequestSetLdapConfigs,
  SuccessSetLdapConfigs,
  FailureSetLdapConfigs,
  RequestToggleLdapStatus,
  RequestGetLlmSettings,
  SuccessGetLlmSettings,
  FailureGetLlmSettings,
  RequestSetLlmSettings,
  SuccessSetLlmSettings,
  FailureSetLlmSettings,
  RequestTestLlmSettings,
  SuccessTestLlmSettings,
  FailureTestLlmSettings,
  ClearLlmTestResult,
  RequestToggleLlmSettings,
  SuccessToggleLlmSettings,
  FailureToggleLlmSettings,
  RequestCoreServers,
  SuccessCoreServers,
  FailureCoreServers,
  RequestUpdateCoreServers,
  SuccessUpdateCoreServers,
  FailureUpdateCoreServers,
  requestGetAutoSubmissionSettings,
  successGetAutoSubmissionSettings,
  failureGetAutoSubmissionSettings,
  requestSetAutoSubmissionSettings,
  successSetAutoSubmissionSettings,
  failureSetAutoSubmissionSettings,
  requestResetAutoSubmissionSettings,
} = settingsSlice.actions;
